<template lang="pug">
.messages.pa-4
  transition-group(
    name="messages",
    enter-active-class="animated slideInRight",
    leave-active-class="animated fadeOut"
  )
    v-alert(
      v-for="{ id, type, text } in messages",
      :key="id",
      :type="type",
      min-width="400",
      max-width="400",
      dismissible
    ) {{ text }}
</template>

<script>
export default {
  computed: {
    messages() {
      return this.$store.state.messages;
    },
  },

  watch: {
    messages(val) {
      if (val.length > 3) {
        this.$store.commit("deleteMessage", val[val.length - 1].id);
      }
      setTimeout(() => {
        this.$store.commit("deleteMessage", val[0].id);
      }, 2000);
    },
  },
};
</script>

<style lang="sass" scoped>
.messages
  position: fixed
  top: 0
  right: 0
  z-index: 1000
</style>